import { Component } from "react";
import { Link } from "react-router-dom";
import './index.sass';

export default class Footer extends Component {


    render() {
        return (
            <div className='footer'>
                <a className='mgrl10' href=''>磁力圈官网</a>
                {/* <a className='mgrl10' href='http://transport.cili-app.com'>
                    木兰调度
                </a>
                <a className='mgrl10' href='https://admin.cili-app.com/commune/'>我的圈子</a> */}
            </div>
        )
    }
}